import { render, staticRenderFns } from "./Perguntas.vue?vue&type=template&id=4e4605a5&"
import script from "./Perguntas.vue?vue&type=script&lang=js&"
export * from "./Perguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports